import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInit } from '../../../../Contexts/InitProvider';
import Pagination from '../../../../features/Pagination/Pagination';
import { OptionButton } from '../../../../utils/Button';
import { TableSortArrow } from '../../../../utils/IconComp';
import InstOption from '../../../../utils/InstOption';
import { GetDate, GetTime } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TableRow({
    item,
    onMakeImplement,
    onMakeOngoing,
    onMakeDone,
    onMakeIteration,
    handleCreateSupportTicket,
    showActivityModal,
    implement,
    ongoing,
    done
}) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const handleShowMenu = () => {
        setShowMenu((d) => !d);
    };

    return (
        <tr
            key={item?.id}
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>

            <td className="capitalize">
                <span>{item?.productType}</span>
            </td>
            <td>
                <span>{item?.serviceName}</span>
            </td>
            <td onClick={() => navigate(mkRelativeUrl(`/customers/${item?.user?.id}/info`))}>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.user?.organization || '-----'}
                </span>
                <span className="text-secondary text-xs lowercase overflow-hidden text-ellipsis block w-full ">
                    {item?.user?.primaryEmail}
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item?.timeInitiate) || '-----'} <br />
                    <small>{GetTime(item?.timeInitiate)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item?.timeImplement) || '-----'} <br />
                    <small>{GetTime(item?.timeImplement)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item?.timeOngoing) || '-----'} <br />
                    <small>{GetTime(item?.timeOngoing)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item?.timeDone) || '------'} <br />
                    <small>{GetTime(item?.timeDone)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item.timeUpdated) || '-----'} <br />
                    <small>{GetTime(item.timeUpdated)}</small>
                </span>
            </td>
            <td className="text-center capitalize">
                <span className={item?.status === 'completed' ? 'text-secondary' : 'text-warning'}>
                    {item?.status}
                </span>
            </td>
            <td>
                <div className="flex flex-row w-full justify-end relative">
                    <span>
                        <OptionButton onClick={() => handleShowMenu()} />
                        <InstOption showMenu={showMenu} setShowMenu={setShowMenu} className="w-44">
                            <button
                                type="button"
                                onClick={() => showActivityModal({ show: true, data: item })}
                            >
                                View Activity Log
                            </button>
                            <button
                                type="button"
                                onClick={(ev) =>
                                    handleCreateSupportTicket(ev, item?.user?.id, item?.id)
                                }
                            >
                                Create Support Ticket
                            </button>
                            <button type="button" onClick={(ev) => onMakeIteration(ev, item)}>
                                Make Iteration
                            </button>
                            {item?.status === 'initiate' && (
                                <button type="button" onClick={(ev) => onMakeImplement(ev, item)}>
                                    Make {implement}
                                </button>
                            )}
                            {item?.status === 'implement' && (
                                <button type="button" onClick={(ev) => onMakeOngoing(ev, item)}>
                                    Make {ongoing}
                                </button>
                            )}
                            {item?.status !== 'completed' && (
                                <button type="button" onClick={(ev) => onMakeDone(ev, item)}>
                                    Make {done}
                                </button>
                            )}
                        </InstOption>
                    </span>
                </div>
            </td>
        </tr>
    );
}
function TableHeader({ initiate, implement, ongoing, done, sortBy, sortedColumn, sortedHandler }) {
    return (
        <thead>
            <tr>
                <th onClick={() => sortedHandler('id')} scope="col">
                    <span className="">ID</span>
                    <TableSortArrow name="id" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th onClick={() => sortedHandler('product-type')} scope="col">
                    <span>Product Type</span>
                    <TableSortArrow
                        name="product-type"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th onClick={() => sortedHandler('service-name')} scope="col">
                    <span>Service Name</span>
                    <TableSortArrow
                        name="service-name"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th onClick={() => sortedHandler('user')} scope="col">
                    <span>Customer Info.</span>
                    <TableSortArrow name="user" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th
                    onClick={() => sortedHandler('initiate-at')}
                    scope="col"
                    className="w-36 text-center"
                >
                    <span
                    // data-tooltip-id="tblTooltip"
                    // data-tooltip-content="Date of Service Initiate"
                    >
                        {initiate}
                    </span>
                    <TableSortArrow
                        name="initiate-at"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th
                    onClick={() => sortedHandler('implement-at')}
                    scope="col"
                    className="w-36 text-center"
                >
                    <span
                    // data-tooltip-id="tblTooltip"
                    // data-tooltip-content="Date of Service Implement"
                    >
                        {implement}
                    </span>
                    <TableSortArrow
                        name="implement-at"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th
                    onClick={() => sortedHandler('ongoing-at')}
                    scope="col"
                    className="w-36 text-center"
                >
                    <span
                    // data-tooltip-id="tblTooltip"
                    // data-tooltip-content="Date of Service Ongoing"
                    >
                        {ongoing}
                    </span>
                    <TableSortArrow name="ongoing-at" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th
                    onClick={() => sortedHandler('done-at')}
                    scope="col"
                    className="w-30 text-center"
                >
                    <span>{done}</span>
                    <TableSortArrow name="done-at" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th
                    onClick={() => sortedHandler('updated-at')}
                    scope="col"
                    className="w-30 text-center"
                >
                    <span
                        data-tooltip-id="tblTooltip"
                        data-tooltip-content="Date of Service Updated"
                    >
                        Updated At
                    </span>
                    <TableSortArrow name="updated-at" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th
                    onClick={() => sortedHandler('status')}
                    scope="col"
                    className="w-20 text-center"
                >
                    <span>Status</span>
                    <TableSortArrow name="status" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function ServiceManagePageTable({
    data = {},
    onChangePage,
    sortedHandler,
    sortedColumn,
    sortBy,
    onMakeImplement,
    onMakeOngoing,
    onMakeDone,
    onMakeIteration,
    handleCreateSupportTicket,
    showActivityModal
}) {
    const { initInfo } = useInit();

    const { initiate, implement, ongoing, done } = initInfo.steps || {};
    return (
        <div className="service_manage_page_table mb-52">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    initiate={initiate}
                    implement={implement}
                    ongoing={ongoing}
                    done={done}
                    sortedHandler={sortedHandler}
                    sortBy={sortBy}
                    sortedColumn={sortedColumn}
                />
                <tbody>
                    {data && data.servicesList?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={9} className="!text-left">
                                No Service Found!
                            </td>
                        </tr>
                    ) : (
                        data?.servicesList?.map((item) => (
                            <TableRow
                                key={item?.id}
                                item={item}
                                onMakeImplement={onMakeImplement}
                                onMakeOngoing={onMakeOngoing}
                                onMakeDone={onMakeDone}
                                onMakeIteration={onMakeIteration}
                                handleCreateSupportTicket={handleCreateSupportTicket}
                                showActivityModal={showActivityModal}
                                initiate={initiate}
                                implement={implement}
                                ongoing={ongoing}
                                done={done}
                            />
                        ))
                    )}
                </tbody>
            </table>
            <Pagination data={data?.pagination || {}} onChangePage={onChangePage} />
        </div>
    );
}

export default ServiceManagePageTable;
